
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import NodeInstance from "../../Global/nodeAxios";

const getVisaAllocation = createAsyncThunk(
  "api/visa-stock",
  async ({ page, limit, search } = {}) => {
    try {
      const params = new URLSearchParams();
      if (page !== undefined && page !== null) params.append("page", page);
      if (limit !== undefined && limit !== null) params.append("limit", limit);
      if (search && typeof search === "string" && search.trim()) params.append("search", search.trim());
      const query = params.toString() ? `?${params.toString()}` : "";
      const response = await NodeInstance.get(`/dashboard/visa-stock/summary${query}`);
      return response.data;
    } catch (e) {
      throw new Error(e.message);
    }
  }
);

const visaAllocationDataSlice = createSlice({
  name: "visa-stock",
  initialState: {
    data: null,
    pagination: null,
    error: "",
    status: false,
    isLoading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getVisaAllocation.fulfilled, (state, action) => {
        state.data = action.payload.data;
        state.pagination = action.payload.pagination || null;
        state.isLoading = false;
        state.status = true;
      })
      .addCase(getVisaAllocation.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getVisaAllocation.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });
  },
});

export { getVisaAllocation };
export default visaAllocationDataSlice.reducer;
